import { FeedingStage } from '@/common/Enum/feedingstage.enum';
import { NewPlacement, PlacementChicksFeedingProgram } from '@/common/interface/placement.data.model';
import { Component, EventEmitter, Input, Output } from '@angular/core';
import { FormArray, FormBuilder, FormGroup, Validators } from '@angular/forms';
import { DisinfectionprogramService } from '@services/disinfectionprogram.service';
import { FarmService } from '@services/farm.service';
import { LitterService } from '@services/litter.service';
import { LoaderService } from '@services/loader.service';
import { PlacementService } from '@services/placement.service';
import { SupplierService } from '@services/supplier.service';
import { VaccineService } from '@services/vaccine.service';
import { ToastrService } from 'ngx-toastr';
import { Observable } from 'rxjs';

@Component({
  selector: 'app-chicks-feeding-program',
  templateUrl: './chicks-feeding-program.component.html',
  styleUrl: './chicks-feeding-program.component.scss'
})
export class ChicksFeedingProgramComponent {
  @Input() placementId: number | null = null;
  @Output() close: EventEmitter<void> = new EventEmitter<void>();
  placementForm: FormGroup;
  FeedingStage = FeedingStage; 
  public isAuthLoading = false;
  public isLoading$: Observable<boolean>;
  constructor(  private fb: FormBuilder,
    private placementService: PlacementService,
    private toastr: ToastrService,
    private loaderService: LoaderService,){

  }
  ngOnInit(): void {
    this.initializeForm();
    console.log(this.placementId);
    if (this.placementId > 0) {
      this.loadPlacementData(+this.placementId);
    }
  }
  initializeForm() {
    this.placementForm = this.fb.group({
      placementChicksFeedingProgram: this.fb.array([
        this.createFeedingProgramGroup(FeedingStage.PreStarter),
        this.createFeedingProgramGroup(FeedingStage.Starter),
        this.createFeedingProgramGroup(FeedingStage.Grower),
        this.createFeedingProgramGroup(FeedingStage.Finisher)
      ])
    });
  }
  loadPlacementData(placementId: number) {
    this.placementService.getPlacementById(placementId).subscribe((placement: NewPlacement) => {
      // Patch the basic placement data
      // Handle placementChicksFeedingProgram array
      const feedingProgramsArray = this.placementChicksFeedingProgram;
      while (feedingProgramsArray.length) {
        feedingProgramsArray.removeAt(0);
      }
      placement.placementChicksFeedingProgram.forEach(program => {
        const group = this.createFeedingProgramGroupFromData(program);
        feedingProgramsArray.push(group);
      });

      // Update other fields or methods if needed
      
    });
  }
  createFeedingProgramGroup(stageId: FeedingStage): FormGroup {
    return this.fb.group({
      id: [0], // Initialize with 0 or null
      placementId: [0], // This will be set when submitting the form
      stageId: [stageId, Validators.required],
      agefrom: ['', [Validators.required, Validators.min(0)]],
      ageTo: ['', [Validators.required, Validators.min(0)]],
      chicksQty: ['', [Validators.required, Validators.min(0)]]
    });
  }
  createFeedingProgramGroupFromData(data: any): FormGroup {
    return this.fb.group({
      id: [data.id],
      placementId: [data.placementId],
      stageId: [data.stageId, Validators.required],
      agefrom: [data.agefrom, [Validators.required, Validators.min(0)]],
      ageTo: [data.ageTo, [Validators.required, Validators.min(0)]],
      chicksQty: [data.chicksQty, [Validators.required, Validators.min(0)]]
    });
  }

  get placementChicksFeedingProgram() {
    return this.placementForm.get('placementChicksFeedingProgram') as FormArray;
  }
  isControlInvalid(controlName: string): boolean {
    const control = this.placementForm.get(controlName);
    return control?.invalid && (control.touched || control.dirty);
  }
  isControlInvalidFeed(controlName: string, formGroup: FormGroup): boolean {
    const control = formGroup.get(controlName);
    return control?.invalid && (control.touched || control.dirty);
  }
  private markFormGroupTouched(formGroup: FormGroup | FormArray) {
    Object.values(formGroup.controls).forEach(control => {
      if (control instanceof FormGroup || control instanceof FormArray) {
        this.markFormGroupTouched(control);
      } else {
        control.markAsTouched();
      }
    });
  }
  onSubmit() {
    this.markFormGroupTouched(this.placementForm);
    this.loaderService.showLoader();
    this.isAuthLoading = true;
    if (this.placementForm.valid) {
      const formValue = this.placementForm.value;

      // Extract the PlacementChicksFeedingProgram from form value
      const feedingPrograms: PlacementChicksFeedingProgram[] = formValue.placementChicksFeedingProgram.map((item: any) => ({
        id: item.id,
        placementId: this.placementId,
        stageId: item.stageId,
        agefrom: item.agefrom,
        ageTo: item.ageTo,
        chicksQty: item.chicksQty,
      }));

      if (this.placementId) {
        // Update operation
        const updateModel = {
          id: this.placementId, // Placement ID
          placementChicksFeedingProgram: feedingPrograms,
        };
        
        this.placementService.updateChicksFeedingProgram(updateModel)
          .subscribe({
            next: (response: any) => {
              setTimeout(() => {
                this.isAuthLoading = false;
                this.loaderService.hideLoader();
                this.toastr.success("Placement Feeding Program Updated");
                this.close.emit();
              }, 2000);
            },
            error: (error) => {
              setTimeout(() => {
                this.isAuthLoading = false;
                this.loaderService.hideLoader();
                this.toastr.error("Error Updating Placement Feeding Program");
              }, 2000);
              
            }
          });
        }
      }
    else {
      this.isAuthLoading = false;
      this.loaderService.hideLoader();
      this.toastr.error("Form is not valid")
    }

  }
}
